
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { CheckCircle, Mail, ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useToast } from "@/hooks/use-toast"

export default function Success() {
  const navigate = useNavigate()
  const { toast } = useToast()

  useEffect(() => {
    toast({
      title: "Order Successfully Submitted",
      description: "Thank you for your purchase! Check your email for your receipt and order confirmation.",
    })
  }, [toast])

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full mx-auto p-6 bg-white rounded-lg shadow-md">
        <div className="flex justify-center mb-6">
          <CheckCircle className="h-16 w-16 text-green-500" />
        </div>
        <h1 className="text-3xl font-bold mb-4 text-center">Order Complete!</h1>
        <p className="text-lg text-muted-foreground mb-6 text-center">
          Thank you for your purchase. We'll begin processing your cease and desist letter right away.
        </p>
        
        <div className="bg-purple-50 p-4 rounded-lg mb-6">
          <h2 className="text-xl font-semibold mb-2 flex items-center gap-2">
            <Mail className="h-5 w-5 text-purple-600" />
            Check Your Email
          </h2>
          <p className="text-sm text-gray-700">
            We've sent the following emails to the address you provided:
          </p>
          <ul className="mt-2 text-sm text-gray-700 space-y-1 list-disc pl-5">
            <li>A payment receipt with your order details</li>
            <li>A confirmation email with a copy of your letter</li>
          </ul>
          <p className="text-sm text-gray-700 mt-2">
            If you don't see them, please check your spam or junk folder.
          </p>
        </div>
        
        <div className="text-center space-y-4">
          <Button 
            onClick={() => navigate("/")} 
            className="w-full"
            variant="default"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Return Home
          </Button>
          <p className="text-sm text-gray-500 mt-4">
            Have questions about your order? 
            <a onClick={() => navigate("/contact")} className="text-purple-600 ml-1 hover:underline cursor-pointer">
              Contact us
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
